<template>
  <div id="assist__reward">
    <NavFooter />
    <Poster
      v-if="isShowPoster"
      :selectedRule="{ id: info.type }"
      v-on:close="isShowPoster = false"
    />
    <Top
      title="我的直播课奖励"
      icon="anyteachicon anyteach-homeclass"
      sub="邀请好友助力，最高赢取 30 天欧美外教少儿英语直播课"
      desc="邀请 10 人晋升城市合伙人"
      :noPaddingBottom="false"
    />
    <div v-if="info === undefined" class="empty">
      <InlineLoading />
    </div>
    <div v-else-if="!info">
      <Error title="暂无奖励" sub="您还未发起助力活动" :showButton="false" />
      <Rule btnType="start" />
    </div>
    <div v-else>
      <section>
        <h2>奖励课程</h2>
        <p v-if="remaining && info.assist_status == 1" class="body">
          还差 {{ remaining }} 次助力晋升城市合伙人
        </p>
        <Course :info="info" :remaining="remaining" />
        <div class="buttons" v-if="remaining">
          <div @click="isShowPoster = true" class="btn-primary">
            <i class="anyteachicon anyteach-post"></i>
            <span>生成海报</span>
          </div>
          <router-link tag="div" :to="url" class="btn-link">查看我的助力进度</router-link>
        </div>
        <div v-else class="success animated fadeIn">
          成功晋升城市合伙人
          <i class="anyteachicon anyteach-shenfen1" />
        </div>
      </section>
      <How :info="info" :remaining="remaining" v-on:stop="getInfo" />
      <!-- <Rule /> -->
    </div>
  </div>
</template>

<script>
import Top from "../Top"
import Rule from "../rule/Rule"
import Course from "./Course"
import How from "./How"
import Poster from "../rule/Poster"
import Error from "@/components/assist/Error"
import NavFooter from "@/components/public/footer"
export default {
  name: "AssistReward",
  components: {
    Top,
    Rule,
    Error,
    Course,
    How,
    Poster,
    NavFooter,
  },
  data() {
    return {
      info: undefined,
      isShowPoster: false,
      ar_id: null,
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    remaining() {
      return this.info.limit_time - this.info.assist_user.length
    },
    url() {
      return `/assist?ar_id=${this.info.id}&user_id=${this.user.user_id}`
    },
  },
  watch: {
    user(val) {
      this.getSelectedRule()
    },
  },
  methods: {
    async getSelectedRule() {
      const res = await this.$api.assist.SELECTED_RULE()
      if (!res) {
        return (this.info = null)
      }
      const { id } = res.find(item => item.type == 1)
      this.ar_id = id
      this.getInfo(id)
    },
    async getInfo() {
      this.info = await this.$api.assist.INFO({
        ar_id: this.ar_id,
        user_id: this.user.user_id,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
.empty {
  height: 30vh;
}

#assist__reward {
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;

  h2 {
    margin-bottom: 10px;
  }

  .buttons {
    margin-top: 20px;
  }

  .success {
    font-size: 1rem;
    @include avenir-demi();
    color: $purple;
    i {
      font-weight: 400;
    }
  }
}
</style>
